import { Coordinate } from './coodinate';
import { Rectangle } from './reactangle';
import { z } from 'zod';

export const AreaModel = z.object({
    guid: z.string().nullish(),
    name: z.string().nullish(),
    bounds: Coordinate.array().nullish(),
    textBounds: Rectangle.nullish(),
    flags: z.string().array().nullish(),
    maxDwellTimeInSeconds: z.number().int().nonnegative().nullish(),
    commodityGroups: z
        .object({
            id: z.string(),
            name: z.string().nullish(),
        })
        .array()
        .nullish(),
});
export type AreaModel = z.infer<typeof AreaModel>;
